export const TIMEZONES = [
  // United States
  { value: 'America/New_York', label: 'Eastern Time (ET)' },
  { value: 'America/Chicago', label: 'Central Time (CT)' },
  { value: 'America/Denver', label: 'Mountain Time (MT)' },
  { value: 'America/Phoenix', label: 'Mountain Time - Arizona (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time (HT)' },
  { value: 'America/Puerto_Rico', label: 'Atlantic Time (AT)' },

  // Canada
  { value: 'America/St_Johns', label: 'Newfoundland Time (NT)' },
  { value: 'America/Halifax', label: 'Atlantic Time - Canada (AT)' },
  { value: 'America/Toronto', label: 'Eastern Time - Canada (ET)' },
  { value: 'America/Winnipeg', label: 'Central Time - Canada (CT)' },
  { value: 'America/Edmonton', label: 'Mountain Time - Canada (MT)' },
  { value: 'America/Vancouver', label: 'Pacific Time - Canada (PT)' },

  // Europe
  { value: 'Europe/London', label: 'British Time (GMT/BST)' },
  { value: 'Europe/Dublin', label: 'Ireland (GMT/IST)' },
  { value: 'Europe/Paris', label: 'Central European Time (CET)' },
  { value: 'Europe/Berlin', label: 'Germany (CET)' },
  { value: 'Europe/Rome', label: 'Italy (CET)' },
  { value: 'Europe/Madrid', label: 'Spain (CET)' },
  { value: 'Europe/Amsterdam', label: 'Netherlands (CET)' },
  { value: 'Europe/Brussels', label: 'Belgium (CET)' },
  { value: 'Europe/Stockholm', label: 'Sweden (CET)' },
  { value: 'Europe/Oslo', label: 'Norway (CET)' },
  { value: 'Europe/Copenhagen', label: 'Denmark (CET)' },
  { value: 'Europe/Athens', label: 'Eastern European Time (EET)' },
  { value: 'Europe/Istanbul', label: 'Turkey (TRT)' },
  { value: 'Europe/Moscow', label: 'Moscow Time (MSK)' },

  // Asia
  { value: 'Asia/Dubai', label: 'Gulf Time (GST)' },
  { value: 'Asia/Riyadh', label: 'Arabia Time (AST)' },
  { value: 'Asia/Kolkata', label: 'India Time (IST)' },
  { value: 'Asia/Bangkok', label: 'Indochina Time (ICT)' },
  { value: 'Asia/Singapore', label: 'Singapore Time (SGT)' },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong Time (HKT)' },
  { value: 'Asia/Shanghai', label: 'China Time (CST)' },
  { value: 'Asia/Tokyo', label: 'Japan Time (JST)' },
  { value: 'Asia/Seoul', label: 'Korea Time (KST)' },

  // Australia & Pacific
  { value: 'Australia/Perth', label: 'Western Time - Australia (AWST)' },
  { value: 'Australia/Adelaide', label: 'Central Time - Australia (ACST)' },
  { value: 'Australia/Darwin', label: 'Central Time - NT (ACST)' },
  { value: 'Australia/Brisbane', label: 'Eastern Time - Queensland (AEST)' },
  { value: 'Australia/Sydney', label: 'Eastern Time - New South Wales (AEST)' },
  { value: 'Australia/Melbourne', label: 'Eastern Time - Victoria (AEST)' },
  { value: 'Pacific/Auckland', label: 'New Zealand Time (NZST)' },

  // South America
  { value: 'America/Sao_Paulo', label: 'Brasilia Time (BRT)' },
  { value: 'America/Buenos_Aires', label: 'Argentina Time (ART)' },
  { value: 'America/Santiago', label: 'Chile Time (CLT)' },
  { value: 'America/Lima', label: 'Peru Time (PET)' },
  { value: 'America/Bogota', label: 'Colombia Time (COT)' }
]; 